import heroBenefitsLogo from "@/assets/hero-benefits-alliance.png.asset.json";

/**
 * Partner-branded signup pages served at /p/<slug>. Every signup from a page is
 * tagged with lead source "partner-<slug>" so the monthly partner report can
 * count it. To add a partner, add one entry here — no other code changes.
 */
export interface PartnerPage {
  slug: string;
  name: string;
  logoUrl?: string;
  headline: string;
  intro: string;
  /** Short perks shown as a list. */
  perks: string[];
  /** Aggregate monthly report recipients at the partner (counts only, never member details). */
  reportEmails?: string[];
  /** "employer" pages tag signups with the employer so Stack's employer layer works and add the privacy promise. */
  kind?: "community" | "employer";
  /** Employer name saved on each signup's profile (employer pages only). */
  employerName?: string;
}

/** Shown on every employer page before anyone types anything personal. Single source lives in disclosuresCopy. */
export { EMPLOYER_PRIVACY_LINE } from "@/data/disclosuresCopy";

export const PARTNER_PAGES: PartnerPage[] = [
  {
    slug: "hero-benefits-alliance",
    name: "Hero Benefits Alliance",
    logoUrl: heroBenefitsLogo.url,
    headline: "Your free homebuying toolkit, brought to you by Hero Benefits Alliance",
    intro:
      "Find the down payment help you may qualify for, see your next step, and get a real person when you're ready. Free, no credit pull.",
    perks: [
      "Your personal Stack of grants and assistance programs for your ZIP",
      "Homie, your homebuying guide, available any time",
      "An introduction to a lender or real estate expert when you ask for one",
    ],
  },
];

export const partnerLeadSource = (slug: string) => `partner-${slug}`;

export function getPartnerPage(slug: string): PartnerPage | undefined {
  return PARTNER_PAGES.find((p) => p.slug === slug);
}
